<template>
  <div class="p-3">
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div>
      <h2>Add New User</h2>
      <h6 class="mt-2 mb-5">Create a brand new user and add them to this site.</h6>
      <div class="row">
        <div class="col-md-5 col-sm-8 rounded border pt-3" style="background-color: white;">
          <!-- userType -->
          <div class="userType d-flex flex-column userInputField ">
            <label class="form-label" for="userTypeControlInput ">User Type* (required)</label>
            <select id="mySelect" v-model="user.user_type" :disabled="edit"
                    class="py-2 border rounded px-1" @change="usertypeSelected">
              <option :value="null" disabled>-- Select User Type --</option>
              <option value="1">Internal</option>
              <option value="2">External</option>
            </select>
          </div>
          <!-- Select Internal Users -->
          <div v-if="isInternalEmployee && !edit" class="internal d-flex flex-column userInputField ">
            <label class="form-label" for="internalControlInput">Select Internal User* (required)</label>
            <select id="mySelect" v-model="internalUserInfo" class="py-2 border rounded px-1"
                    @change="internalInfoSelected">
              <option v-for="(info, index) in internalUsers" :key="index" :value="info">
                {{ info.emp_name }}
              </option>
            </select>
          </div>
          <!-- Name -->
          <div v-if="!isInternalEmployee || edit" class="Name">
            <label class="form-label" for="nameControlInput">Name* (required)</label>
            <b-form-input id="nameControlInput" v-model="user.user_name" :disabled="edit && user.user_type == 1"
                          class="form-control userInputField" placeholder="Your Name" type="name"/>
          </div>
          <!-- Email -->
          <div v-if="!isInternalEmployee" class="UserId">
            <label class="form-label">User Email* (required)</label>
            <input id="userIdControlInput" v-model="user.user_email" class="form-control userInputField"
                   placeholder="Your Email" type="email"/>
          </div>
          <!-- User Id -->
          <div v-if="isInternalEmployee" class="UserId">
            <label class="form-label" for="userIdControlInput">User ID (email)* (required)</label>
            <input id="userIdControlInput" v-model="user.user_id" :disabled="edit"
                   class="form-control userInputField"
                   placeholder="Your ID" type="userId"/>
          </div>
          <div v-else-if="!isInternalEmployee" class="UserId">
            <label class="form-label" for="userIdControlInput">User ID (phone/ID)* (required)</label>
            <input id="userIdControlInput" v-model="user.user_id" :disabled="edit"
                   class="form-control userInputField"
                   placeholder="Your ID" type="userId"/>
          </div>
          <!-- password -->

          <div class="password">
            <label class="form-label" for="passwordControlInput">Password* (required)</label>
            <div class="d-flex flex-row">
              <div class="d-flex flex-row userInputField align-self-center">
                <input id="passwordControlInput" v-model="user.password"
                       :disabled="edit && (allowPasswordEdit ? disabled : '')"
                       :type="showPassword ? 'text' : 'password'" autocomplete="off" class="form-control"
                       placeholder="Password" @input="startValidation"
                       v-on:blur="passwordBlurred = true"/>
                <div v-if="edit">
                  <div class="btn btn-light" @click="allowPasswordEdit = !allowPasswordEdit">
                    <i class="fa-regular fa-pen-to-square align-self-center"
                       style="color: #36b9cc;"></i>

                  </div>
                </div>
              </div>

              <div class="mx-2 align-self-baseline">
                <div v-if="showPassword" role="button align-self-center" @click="toggleShow">
                  <i class="fas fa-eye align-self-center"></i>
                </div>
                <div v-else role="button" @click="toggleShow">
                  <i class="fas fa-eye-slash"></i>
                </div>
              </div>
            </div>
            <div v-if="hasUserStartedTyping" class="password-validation mb-2">
              <div v-if="passwordValidation.capitalLetter">
                ✔️ Contains at least 1 capital letter
              </div>
              <div v-else>
                ❌ Contains at least 1 capital letter
              </div>
              <div v-if="passwordValidation.smallLetter">
                ✔️ Contains at least 1 small letter
              </div>
              <div v-else>
                ❌ Contains at least 1 small letter
              </div>
              <div v-if="passwordValidation.specialChar">
                ✔️ Contains at least 1 special character
              </div>
              <div v-else>
                ❌ Contains at least 1 special character
              </div>
              <div v-if="passwordValidation.digit">
                ✔️ Contains at least 1 digit
              </div>
              <div v-else>
                ❌ Contains at least 1 digit
              </div>
              <div v-if="passwordValidation.length10">
                ✔️ Minimum 10 characters long
              </div>
              <div v-else>
                ❌ Minimum 10 characters long
              </div>
            </div>
            <label class="form-label" for="passwordControlInput">Re-enter Password* (required)</label>
            <div class="d-flex flex-row">
              <div class="userInputField align-self-center">
                <input id="reEnteredpasswordControlInput" v-model="reEnteredpassword"
                       :disabled="edit && (allowPasswordEdit ? disabled : '')"
                       :type="showPassword ? 'text' : 'password'"
                       autocomplete="off" class="form-control"
                       placeholder="Re-enter Password" @input="startValidation"
                       v-on:blur="passwordBlurred = true"/>
              </div>

              <div class="mx-2 align-self-baseline">
                <div v-if="showPassword" role="button align-self-center" @click="toggleShow">
                  <i class="fas fa-eye align-self-center"></i>
                  <!-- <i class="fa-regular fa-pen-to-square text-primary"></i> -->
                </div>
                <div v-else role="button" @click="toggleShow">
                  <i class="fas fa-eye-slash"></i>
                </div>
              </div>
            </div>
            <div v-if="hasUserStartedTyping && reEnteredpassword.length > 2" class="password-validation mb-2">
              <div v-if="passwordValidation.match">
                ✔️ Password matched
              </div>
              <div v-else>
                ❌ Password not matched
              </div>

            </div>
          </div>
          <!-- Phone -->
          <div class="">
            <label class="form-label" for="departmentControlInput">Phone No* (required)</label>
            <input id="sControlInput" v-model="user.phone_no"
                   class="form-control userInputField"
                   placeholder="Your Phone No"
                   type="phone"/>
          </div>
          <!-- UserRole -->
          <div class="userRole d-flex flex-column userInputField ">
            <label class="form-label" for="userTypeControlInput">User Role* (required)</label>

            <div class="rounded border p-2" style="max-height: 150px; overflow-y:scroll;">
              <ul class="text-dark" style="list-style-type: none;">
                <li v-for="(info, index) in rolesArray" :key="index" class="popular-category">
                  <label class="selectit">
                    <input :id="info.name" v-model="user.roles" :value="info.role_id" class="checkbox-input"
                           type="checkbox"/>
                    {{ info.role_name }}
                  </label>
                </li>
              </ul>
            </div>
          </div>

          <!-- Department Name -->
          <div class="Department Name">
            <label class="form-label" for="departmentControlInput">Department Name* (required)</label>
            <input id="sControlInput" v-model="user.department_name"
                   :disabled="isInternalEmployee || (edit && user.user_type == 1)"
                   class="form-control userInputField"
                   placeholder="Your Department Name"
                   type="department"/>
          </div>
          <!-- Designation Name -->
          <div class="Designation Name">
            <label class="form-label" for="designationControlInput">Designation Name* (required)</label>
            <input id="sControlInput" v-model="user.designation"
                   :disabled="isInternalEmployee || (edit && user.user_type == 1)"
                   class="form-control userInputField"
                   placeholder="Your Designation Name" type="designation"/>
          </div>
          <div v-if="permissions.UPDATE_USERS == 'Y'">
            <div v-if="!edit" class="mb-3 mt-4">
              <button class="btn btn-dark" type="submit" @click="handleAddUser">
                Add User
              </button>
            </div>
            <div v-if="edit" class="d-flex gap-2 mb-3 mt-4">
              <button class="btn btn-dark" type="submit" @click="updateUser">
                Update User
              </button>
              <button class="btn btn-dark" type="submit" @click="cancelUpdate">
                Cancel
              </button>
            </div>
          </div>
          <div v-else class="text-danger mt-1 mb-4">
            You don't have the permission to add/edit Users.
          </div>

        </div>
        <div class="col-md-7 col-sm-8">
          <div class="rounded border p-4" style="background-color: white;">
            <div class="p-2">
              <h3>User List</h3>
            </div>
            <!-- page size  -->
            <b-row class="mt-2">
              <b-col class="col-4 p-1" lg="3" md="4">
                <b-form-group class="ms-2">
                  <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"
                                 class="col-md-4" size="sm" @change="handlePageSizeChange"></b-form-select>
                </b-form-group>
              </b-col>
              <!-- search  -->
              <b-col>
                <div class="d-flex flex-row">
                  <b-form-input v-model="filter" :formatter="searchFormatter" class="me-2"
                                placeholder="Type to filter data" type="search"></b-form-input>
                  <button class="rounded btn-info me-4" @click="onSearch">Search</button>
                </div>
              </b-col>

            </b-row>
            <b-table :busy="loading" :current-page="currentPage" :fields="fields" :items="allUsers" :per-page="perPage"
                     bordered hover
                     responsive striped>
              <template #cell(actions)="row">
                <div class="d-flex gap-1 justify-content-center">
                  <button v-if="permissions.UPDATE_USERS == 'Y'" class="btn btn-info btn-sm" type="button"
                          @click="editUser(row.item)">
                    <i class="fa-regular fa-pen-to-square"></i>
                  </button>
                  <button v-if="permissions.DELETE_USERS == 'Y'"
                          class="btn btn-danger btn-sm delete-button" @click="deleteUser(row.item)"><span
                      class="fa-solid fa-trash"></span></button>
                </div>
              </template>
              <template #table-busy>
                <div class="text-center text-danger my-2 px-2">
                  <b-spinner class="align-middle mx-2"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
            </b-table>
            <!-- Pagination -->
            <b-row>
              <b-col class="mt-2" md="12" sm="12">
                <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows"
                              align="center" class="my-0" next-text="Next" prev-text="Prev"
                              @click="handlePageChange"></b-pagination>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {notify} from "@kyvg/vue3-notification";
import AllUserService from '@/services/all-users.service';
import userService from '@/services/user.service';
import roleService from '@/services/role.service';
import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css";
import {isStringNull} from "@/helpers";


export default {
  name: "AddUserPage",
  computed: {
    rolesArray: function () {
      return this.roles.filter(i => i.active_yn === 'Y')
    },
    isPasswordValid() {
      return (
          this.passwordValidation.specialChar &&
          this.passwordValidation.capitalLetter &&
          this.passwordValidation.smallLetter &&
          this.passwordValidation.length10 &&
          this.passwordValidation.digit
      );
    },

  },
  created() {
    this.permissions = JSON.parse(localStorage.getItem("permissions"));
    this.getAllUsers();
    this.fetchRoles();
    this.fetchInternalUsers();
  },
  data() {
    return {
      allowPasswordEdit: false,
      permissions: {},
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'User',
          href: '#'
        }, {
          text: 'Add User',
          href: '#'
        }
      ],
      fields: [
        {
          label: 'Name', key: 'user_name', sortable: true, thStyle: {width: "22%"},
          tdClass: "px-3", thClass: "px-3",
        },
        {
          label: 'User ID', key: 'user_id', sortable: true,
          thStyle: {width: "20%"}, tdClass: "px-3", thClass: "px-3",
        },
        {
          label: 'Roles', key: 'rolesString', sortable: true, thStyle: {width: "23%"},
          tdClass: "px-3", thClass: "px-3",
        },
        {
          key: 'user_type', label: 'Categories', sortable: false,
          class: 'text-center', thStyle: {width: "15%"},
          formatter: (value) => {
            return value == 2 ? 'External' : 'Internal'
          },
          filterByFormatted: true
        },
        {key: 'actions', label: 'Actions', class: 'text-center', thStyle: {width: "20%"},},
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 100],
      allUsers: [],
      showPassword: false,
      submitted: false,
      passwordBlurred: false,
      reEnteredpassword: "",
      user: {
        user_id: "",
        user_name: "",
        password: "",
        user_email: "",
        user_type: null,
        user_role: "",
        user_role_id: [],
        user_status: "Y",
        department_name: "",
        designation_id: "",
        emp_id: "",
        designation: "",
        roles: [],
        phone_no: null,
      },
      loading: false,
      message: sessionStorage.getItem("message"),
      internalUsers: [],
      roles: [],
      filter: '',
      rolesLoaded: false,
      isInternalEmployee: false,
      internalUserInfo: null,
      edit: false,
      backupAllUsers: null,
      passwordValidation: {
        match: false,
        specialChar: false,
        smallLetter: false,
        capitalLetter: false,
        digit: false,
        length10: false,
      },
      hasUserStartedTyping: false,
      form: {
        name: null,
      }
    };
  },

  methods: {
    searchFormatter(data) {
      this.filter = data;
      if (this.filter != null && this.filter != "") {
        this.allUsers = [];
        this.backupAllUsers.forEach(user => {
          if (user.user_name.toLowerCase().includes(this.filter.toLowerCase())) {
            this.allUsers.push(user);
          } else if (user.user_id.toLowerCase().includes(this.filter.toLowerCase())) {
            this.allUsers.push(user);
          } else if (user.user_email.toLowerCase().includes(this.filter.toLowerCase())) {
            this.allUsers.push(user);
          } else if (user.rolesString.toLowerCase().includes(this.filter.toLowerCase())) {
            this.allUsers.push(user);
          }
        });
      } else {
        this.allUsers = this.backupAllUsers;
      }
      this.totalRows = this.allUsers.length;
      this.currentPage = 1;
      return data;
    },

    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    onSearch() {
      if (this.filter != null && this.filter != "") {
        this.allUsers = [];
        this.backupAllUsers.forEach(user => {
          if (user.user_name.toLowerCase().includes(this.filter.toLowerCase())) {
            this.allUsers.push(user);
          }
        });
      } else {
        this.allUsers = this.backupAllUsers;
      }
      this.totalRows = this.allUsers.length;
      this.currentPage = 1;
    },
    async fetchRoles() {
      const response = await roleService.fetchRole()
      if (response.data) {
        this.roles = response.data;

        this.roles.forEach(role => {
          const roleIntValue = parseInt(role.role_id);
          role.role_id = roleIntValue;
        });
        this.rolesLoaded = true;
      }
    },
    async getUserData() {
      return await userService.getUserById();
    },

    async getAllUsers() {
      this.loading = true;
      var response;
      try {
        response = await userService.getAllUsers();
      } catch (error) {
        this.loading = false;
      }
      this.loading = false;

      const currentUserData = await this.getUserData();

      const filteredData = response.data.filter(user => user.user_status === 'Y' && user.user_id !== currentUserData.user_id);
      this.allUsers = filteredData;
      this.allUsers.forEach(user => {
        user.rolesString = "";
        user.roles = [];
        user.user_roles.forEach(roleDetails => {
          user.roles.push(roleDetails.role_id);
          if (user.rolesString === "") {
            user.rolesString = user.rolesString + roleDetails.role_name;
          } else {
            user.rolesString = user.rolesString + ", " + roleDetails.role_name;
          }
        });
      });
      this.backupAllUsers = this.allUsers;
      this.totalRows = this.allUsers.length;
      // this.allUsers = response.data;
    },
    async handleAddUser() {
      if (!this.checkValidation("add")) {
        return;
      }
      this.message = "";
      this.loading = true;
      var response;
      try {
        response = await AllUserService.createNewUser(this.user);
      } catch (error) {
        this.loading = false;
      }
      this.loading = false;
      if (response.data['messageCode'] == 1) {
        notify({
          type: "success",
          title: "Creat User",
          text: response.data.message,
        });
        this.clearValues();
        this.getAllUsers();
      } else {
        notify({
          type: "error",
          title: "Creat User",
          text: response.data.message,
        });
      }
    },
    async updateUser() {
      if (!this.checkValidation("update")) {
        return;
      }
      this.loading = true;
      this.message = "";
      var response;
      try {
        response = await AllUserService.updateUser(this.user);
      } catch (error) {
        this.loading = false;
      }
      this.loading = false;
      this.allowPasswordEdit = false;
      if (response.data['messageCode'] == 1) {
        notify({
          type: "success",
          title: "Update User",
          text: response.data.message,
        });
        this.clearValues();
        this.getAllUsers();
      } else {
        notify({
          type: "error",
          title: "Update User",
          text: response.data.message,
        });
      }
    },
    async fetchInternalUsers() {
      this.loading = true;
      const response = await AllUserService.getInternalUsers();
      if (response.data) {
        this.internalUsers = response.data.data;
      }
      this.loading = false;
    },
    usertypeSelected() {
      this.clearValues();
      if (this.user.user_type == 1) {
        this.isInternalEmployee = true;
      } else if (this.user.user_type == 2) {
        this.isInternalEmployee = false;
      }
    },
    internalInfoSelected() {
      this.user.user_name = this.internalUserInfo.emp_name;
      this.user.emp_id = this.internalUserInfo.emp_id;
      this.user.designation_id = this.internalUserInfo.designation_id;
      this.user.department_name = this.internalUserInfo.department_name;
      this.user.designation = this.internalUserInfo.designation;
    },
    clearValues() {
      this.internalUserInfo = null;
      this.user.user_id = "";
      this.user.user_name = "";
      // this.user.user_type = "";
      this.user.password = "";
      this.user.user_role = "";
      this.user.department_name = "";
      this.user.designation_id = "";
      this.user.emp_id = "";
      this.user.designation = "";
      this.user.user_email = "";
      this.user.user_role_id = [];
      this.user.roles = [];
      this.edit = false;

      this.user.phone_no = null;
      this.reEnteredpassword = "";
    },

    editUser(rowData) {
      if (rowData.user_type == 1) {
        this.isInternalEmployee = true;
      } else {
        this.isInternalEmployee = false;
      }
      this.edit = true;
      this.allowPasswordEdit = false;
      this.user.id = rowData.id;
      this.user.user_type = rowData.user_type;
      this.user.user_name = rowData.user_name;
      this.user.user_id = rowData.user_id;

      this.user.user_role = rowData.user_role_id;
      this.user.user_source = rowData.user_source;
      this.user.user_status = rowData.user_status;
      this.user.roles = rowData.roles;
      this.user.user_email = rowData.user_email;
      this.user.department_name = rowData.department_name;
      this.user.designation_id = rowData.designation_id;
      this.user.emp_id = rowData.emp_id;
      this.user.designation = rowData.designation;

      this.user.phone_no = rowData.phone_no;
    },
    disableInternal() {
      if (this.edit && this.user.user_type == 1) {
        return true;
      }
      return false;
    },
    async deleteUser(user) {
      const result = await this.$swal({
        title: 'Are you sure, you want to delete the User?',
        showCancelButton: true,
        cancelButtonText: 'No',
        cancelButtonColor: '#007bff',
        showConfirmButton: true,
        confirmButtonText: 'Yes',
        confirmButtonColor: '#dd3333',
      });
      if (result.isConfirmed) {
        this.loading = true;
        var response;
        try {
          response = await AllUserService.deleteUser(user.id);
        } catch (error) {
          this.loading = false;
        }
        this.loading = false;

        if (response.data) {
          if (response.data['messageCode'] == 1) {
            notify({
              type: "success",
              title: "Delete User",
              text: response.data.message,
            });
            this.getAllUsers();
          } else {
            notify({
              type: "error",
              title: "Delete User",
              text: response.data.message,
            });
          }
        }
      }
    },
    cancelUpdate() {
      this.edit = false;
      this.allowPasswordEdit = false;
      this.clearValues();
    },
    validate: function () {
      this.emailBlurred = true;
      this.passwordBlurred = true;
      if (this.validEmail(this.email) && this.validPassword(this.password)) {
        this.valid = true;
      }
    },
    validPassword(password) {
      var paswd = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{10,30}$/;
      if (password.match(paswd)) {
        return true;
      } else {
        return false;
      }
    },
    validEmail(email) {
      var re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (re.test(email)) {
        return true;
      }
      return false;
    },
    validPhone(phone) {
      if (isStringNull(phone)) {
        return false;
      }
      var re = /^01\d{9}$/;
      if (re.test(phone.trim())) {
        return true;
      }
      return false;
    },
    startValidation() {
      this.hasUserStartedTyping = true;
      this.validatePassword();
    },
    validatePassword() {
      this.passwordValidation.specialChar = /[!@#$%^&*(),.?":{}|<>]/.test(this.user.password);
      this.passwordValidation.capitalLetter = /[A-Z]/.test(this.user.password);
      this.passwordValidation.smallLetter = /[a-z]/.test(this.user.password);
      this.passwordValidation.digit = /\d/.test(this.user.password);
      this.passwordValidation.length10 = this.user.password.length >= 10;
      this.passwordValidation.match = this.user.password == this.reEnteredpassword;
    },
    checkValidation(addOrupdate) {
      if (isStringNull(this.user.user_type)) {
        notify({
          type: "error",
          title: "Wrong Input",
          text: "Please enter a User Type",
        });
        return false;
      }
      if (isStringNull(this.user.user_name)) {
        notify({
          type: "error",
          title: "Wrong Input",
          text: "Please enter a User Name",
        });
        return false;

      }

      if (this.user.user_type == 1) {
        this.user.user_email = this.user.user_id;
      }
      if (!this.validEmail(this.user.user_email)) {
        notify({
          type: "error",
          title: "Wrong Input",
          text: "Enter a correct email!",
        });
        return false;
      }
      if (this.user.user_type == 2) {
        if (!this.validPhone(this.user.user_id)) {
          notify({
            type: "error",
            title: "Wrong Input",
            text: "Enter a correct phone number!",
          });
          return false;
        }
      }
      if (addOrupdate == 'add') {
        if (!this.validPassword(this.user.password)) {
          notify({
            type: "error",
            title: "Wrong Input",
            text: "Password doesn't match the criteria!",
          });
          return false;
        }
      }

      if (addOrupdate == 'update') {
        if (!this.validPassword(this.user.password) && this.allowPasswordEdit) {
          notify({
            type: "error",
            title: "Wrong Input",
            text: "Password doesn't match the criteria!",
          });
          return false;
        }
      }

      if (addOrupdate == 'add') {
        if (!this.passwordValidation.match) {
          notify({
            type: "error",
            title: "Wrong Input",
            text: "Password doesn't match!",
          });
          return false;
        }
      }

      if (addOrupdate == 'update' && this.user.password.length > 0) {
        if (!this.passwordValidation.match) {
          notify({
            type: "error",
            title: "Wrong Input",
            text: "Password doesn't match!",
          });
          return false;
        }
      }

      if (this.user.roles.length == 0) {
        notify({
          type: "error",
          title: "Wrong Input",
          text: "User has to have at least 1 Role",
        });
        return false;
      }
      if (this.user.user_source != null && this.user.user_source != "sso") {
        if (isStringNull(this.user.department_name)) {
          notify({
            type: "error",
            title: "Wrong Input",
            text: "Enter a correct department name!",
          });
          return false;
        }
        if (isStringNull(this.user.designation)) {
          notify({
            type: "error",
            title: "Wrong Input",
            text: "Enter a correct designation!",
          });
          return false;
        }
      }

      return true;
    },

  },
};
</script>
<style scoped>
.userInputField {
  width: 90%;
  margin-bottom: 10px;
}

.card {
  padding: 20px;
}

.left-section {
  width: 40%;
  margin-right: 10px;
  padding-left: 20px;
}

.right-section {
  width: 60%;
  margin-left: 10px;
}

i {
  height: 5px;
  width: 5px;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  margin-left: 2px;
}
</style>
